import { Button, ButtonGroup } from '@mui/material';
import { GetRowIdParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useRef, useState } from 'react';
import { MarkItViewApi } from '../../../../Apis/Apis';
import { CommodityManagementSiteModel, MarketViewUserModel } from '../../../../Generated/Mark-It-View-Api';
import { StoneXGrid, StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import { StoneXTextField } from '../../../StoneXMui';
import { UpdateSiteModal } from './UpdateSiteModal';
import { UpdateSiteUsersModal } from './UpdateSiteUsersModal';

export default function Sites() {
  
  const gridRef = useRef<AgGridReact<CommodityManagementSiteModel>>(null);
  
  const [sites, setSites] = useState<CommodityManagementSiteModel[]>([]);

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [usersModalOpen, setUsersModalOpen] = useState<boolean>(false);

  const [modalSite, setModalSite] = useState<CommodityManagementSiteModel | undefined>();

  useEffect(() => {
    MarkItViewApi.listCommodityManagementSites(null, true).then((res) => setSites(res.data.rows ?? []));
  }, []);

  const columnDefs = [
    {
      headerName: 'Site Name',
      field: 'siteName',
      width: 150,
      sortable: true,
      flex: 1,
    },
    {
      headerName: 'Company',
      colId: 'companyName',
      valueGetter: (params: any) => params.data?.company?.name ?? '',
      sortable: true,
      flex: 1,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      width: 150,
      cellRenderer: (params: any) => {
        return (
          <ButtonGroup variant="text">
            <Button onClick={() => openSiteModal(params.data)}>Edit</Button>
            <Button onClick={() => openUsersModal(params.data)}>Users</Button>
          </ButtonGroup>
        );
      },
    },
  ];

  function openSiteModal(site?: CommodityManagementSiteModel) {
    setModalSite(site);
    setModalOpen(true);
  }

  function closeSiteModal() {
    setModalSite(undefined);
    setModalOpen(false);
  }

  function openUsersModal(site: CommodityManagementSiteModel) {
    setModalSite(site);
    setUsersModalOpen(true);
  }

  function closeUsersModal() {
    setModalSite(undefined);
    setUsersModalOpen(false);
  }

  function saveSite(site: CommodityManagementSiteModel) {
    if (modalSite) {
      setSites((previous) => previous.map((current) => (current.siteGuid === site.siteGuid ? site : current)));
    }
    else {
        setSites((previous) => [...previous, site]);
    }
  }

  function onFilterUpdate(flterText: string) {
    gridRef.current!.api.setGridOption('quickFilterText', flterText);
  }

  return (
    <StoneXMainPage>
      <StoneXRow>
        <h3>Sites</h3>
        <Button className="pull-right" variant="outlined" onClick={() => openSiteModal()}>Add</Button>
      </StoneXRow>
      <StoneXRow>
        <StoneXTextField placeholder="Filter..." onUpdate={onFilterUpdate}/>
      </StoneXRow>
      <div className="ag-theme-alpine" style={{ width: '100%' }}>
        <StoneXGrid
          ref={gridRef}
          getRowId={(params: GetRowIdParams) => params.data.siteGuid}
          columns={columnDefs}
          rows={sites}
          gridOptions={{pagination: true, paginationPageSize: 50}}
          hideGridOptions
        />
      </div>

      <UpdateSiteModal open={modalOpen} onClose={closeSiteModal} onSave={saveSite} site={modalSite} />
      <UpdateSiteUsersModal open={usersModalOpen} onClose={closeUsersModal} site={modalSite} />
    </StoneXMainPage>
  );
}

